function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAdminBadge = function SvgAdminBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.475 21"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53746"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25835",
    d: "M15.839 2.421 6.6 5.486l.236 6.477c.7 7.51 8.953 10.916 8.953 10.916s8.694-3.18 9.448-10.686l.011-7.086-8.9-2.685z",
    transform: "translate(-5.809 -2.132)",
    style: {
      fill: "#3f54d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25836",
    d: "m96.179 6.681-.265 6.084c-.8 7.747-9.8 11.293-9.8 11.293a4.966 4.966 0 0 1-.513-.047V3.743l1.044.032z",
    transform: "translate(-75.367 -3.294)",
    style: {
      fill: "#2545b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25837",
    d: "M10.651 0a5.7 5.7 0 0 1 1.792.288l7.637 2.525a1.811 1.811 0 0 1 1.265 1.5c.33 2.76.675 12.091-8.741 16.277a4.842 4.842 0 0 1-1.953.41 4.781 4.781 0 0 1-2.185-.527C5.08 18.725-.519 14.3.033 4.345a1.828 1.828 0 0 1 1.284-1.6L8.882.281A5.7 5.7 0 0 1 10.651 0zm0 20.119a3.955 3.955 0 0 0 1.595-.337c8.865-3.942 8.536-12.759 8.224-15.368a.94.94 0 0 0-.667-.766l-7.637-2.524a4.867 4.867 0 0 0-3.011-.006L1.59 3.583a.944.944 0 0 0-.677.81c-.524 9.465 4.76 13.647 7.957 15.3a3.9 3.9 0 0 0 1.781.427z",
    transform: "translate(.005)",
    style: {
      fill: "#dbdde6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25838",
    d: "M33.88 25.76a4.055 4.055 0 0 1 1.275.2l5.353 1.769a1.331 1.331 0 0 1 .928 1.1c.233 1.945.476 8.521-6.162 11.472a3.455 3.455 0 0 1-1.394.295 3.413 3.413 0 0 1-1.56-.376c-2.387-1.232-6.332-4.347-5.943-11.363a1.343 1.343 0 0 1 .942-1.176l5.3-1.728a4.056 4.056 0 0 1 1.261-.193zm0 14.1a2.709 2.709 0 0 0 1.093-.231c6.174-2.745 5.945-8.889 5.728-10.707a.6.6 0 0 0-.425-.485l-5.353-1.769a3.348 3.348 0 0 0-2.072 0l-5.3 1.728a.6.6 0 0 0-.432.513c-.366 6.6 3.316 9.513 5.544 10.663a2.669 2.669 0 0 0 1.217.289z",
    transform: "translate(-23.199 -22.682)",
    style: {
      fill: "#dbdde6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25839",
    d: "M57.14 64.279a.533.533 0 0 1-.33-.114l-2.77-2.177a.535.535 0 1 1 .662-.842l2.367 1.86 4.573-5.331a.535.535 0 1 1 .813.7l-4.907 5.721a.534.534 0 0 1-.408.183z",
    transform: "translate(-47.399 -50.618)",
    style: {
      fill: "#dbdde6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29493",
    transform: "translate(.001)",
    style: {
      fill: "none"
    },
    d: "M0 0h21.474v21H0z"
  })));
};

export default SvgAdminBadge;